export type BenchmarkSource = 'ticker' | 'market_series';

type BuildBenchmarkRequestParams = {
  key: string;
  source: BenchmarkSource;
  fromDate: string;
  toDate: string;
  dayKey: string;
};

export const buildBenchmarkRequest = ({
  key,
  source,
  fromDate,
  toDate,
  dayKey,
}: BuildBenchmarkRequestParams) => {
  if (source === 'market_series') {
    return {
      kind: 'market_series' as const,
      url: `/api/market-series?symbols=${encodeURIComponent(key)}&from=${fromDate}&to=${toDate}&day=${dayKey}`,
    };
  }

  return {
    kind: 'ticker' as const,
    url: `/api/ticker-price-history/${encodeURIComponent(key)}?day=${dayKey}`,
  };
};
